import { Component, Input, OnInit } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'video-link-control',
    templateUrl: 'video-link.control.html',
    styleUrl: './video-link.control.scss',
    standalone: false,
})
export class VideoLinkControl extends ControlBase implements OnInit {
    @Input()
    url: string;

    @Input()
    title: string;

    ngOnInit(): void {
        if (!this.url) {
            throw new Error('VideoLinkComponent url is empty');
        }
        if (!this.title) {
            throw new Error('VideoLinkComponent title is empty');
        }
    }

    public onVideoIconClick(): void {
        window.open(this.url);
    }
}
